export default class MagicActionResponse {
  constructor(obj) {
    if (!obj) obj = {};
    this.name = obj.name ? obj.name : "";
    this.type = obj.type ? obj.type : "";
    this.validationType = obj.validationType ? obj.validationType : "";
    this.isSoftDeleted = obj.isSoftDeleted ? obj.isSoftDeleted : false;
    const actionSupport = obj.action ? obj.action.toLowerCase() : null;
    this.action = obj.action ? `${actionSupport}-support` : "upload-support";
  }
}
